export enum ImageType {
  BACKGROUND = "background",
  MAIN = "main",
  HERO = "hero",
  HERO_LANDSCAPE = "hero_horizontal",
  THUMBNAIL = "thumbnail",
  THUMBNAIL_FEATURED = "thumbnail_featured",
  HEADER_LANDSCAPE = "header_landscape",
  HEADER_PORTRAIT = "header_portrait",
  PUBLISHER_PROMOTIONAL = "publisher_promotional",
  GAME_HERO = "gamehero",
  EXCLUSIVE_CONTENT = "exclusive_content",
}

export interface Image {
  id: string;
  uuid: string;
  type: ImageType;
  url: string;
  urlMini?: string;
  theme?: string;
  brandedOption?: "brandedLight" | "brandedDark";
  derivative?: string;
  kind?: string;
}

export const getImageByThemeName = (
  themeName: string,
  images: Image[],
): Image | undefined => {
  for (const image of images) {
    if (image.theme === themeName) return image;
  }
  // return the first image available
  if (images.length > 0) {
    return images[0];
  }
  return undefined;
};
